import React from 'react';
import FooterTwo from '../../components/Footer/FooterTwo';
import HeaderFour from '../../components/Header/HeaderFour';
import FaqMain from './FaqMain';

import Logo from '../../assets/img/logo/sanasa-logo-white.png';

const Faq = () => {
  return (
    <>
      <HeaderFour />

      <FaqMain />

      <FooterTwo
        footerClass="it-footer-area it-footer-bg it-footer-style-5 ed-footer-style-5 inner-style black-bg pb-70"
        footerLogo={Logo}
        btnClass="it-btn-white sky-bg"
        copyrightTextClass="it-copyright-text inner-style text-center"
      />
    </>
  );
};
export default Faq;
